import { UTCDeliveryPeriod } from '@epicuro-next/ataraxia/models';
import { getDeliveryShopId } from '@epicuro-next/utilities';
import { OrderType } from 'graphql-api/gql-api-interfaces';

import {
  BulkTypeDeliveryPeriod,
  BusinessState,
  DeliveryPeriodType,
  UiState,
} from '../../../models';
import { updateShopsWithBulkDeliveryPeriod } from '../update-shops-with-new-selected-delivery-period/update-shops-with-bulk-delivery-period';

/** Select clicked Bulk period as well as changes current selection for DeliveryPeriodType */
export function selectBulkDeliveryPeriodBusiness(
  state: BusinessState,
  { from, to }: UTCDeliveryPeriod,
): BusinessState {
  if (!from || !to) {
    return state;
  }

  const fromJson = from;
  const toJson = to;

  const deliveryShopId = getDeliveryShopId(state.activeDeliveryShop);
  const deliveryPeriodsByShop = state.deliveryPeriods[deliveryShopId] ?? {};
  const deliveryPeriodsByType =
    deliveryPeriodsByShop[DeliveryPeriodType.Bulk] ?? {};
  const shopAndTypeDeliveryPeriods =
    deliveryPeriodsByType.deliveryPeriods ?? [];

  const nextSelectedDeliveryPeriod = shopAndTypeDeliveryPeriods?.find(
    ({ from: existingFrom, to: existingTo }: BulkTypeDeliveryPeriod) =>
      existingFrom === fromJson && existingTo === toJson,
  );

  if (!nextSelectedDeliveryPeriod) {
    return {
      ...state,
    };
  }

  return {
    ...state,
    deliveryPeriods: updateShopsWithBulkDeliveryPeriod(
      state.deliveryPeriods ?? {},
      nextSelectedDeliveryPeriod,
    ),
  };
}

/** Select clicked Bulk period as well as changes current selection for DeliveryPeriodType */
export function selectBulkDeliveryPeriodUi(state: UiState): UiState {
  return {
    ...state,
    selectedOrderType: OrderType.Future,
  };
}
